import jwt from 'jsonwebtoken'
import { User } from "../types/user"

interface Storage {
  setItem: (key: string, value: any) => void
  getItem: (key: string) => any | undefined
  removeItem: (key: string) => void
}

class AuthProvider {
  private tokenKey = process.env.REACT_APP_TOKEN_KEY || 'token'

  constructor(private storage: Storage) {}

  saveToken(token: string): void {
    this.storage.setItem(this.tokenKey, token)
  }

  getToken(): string {
    return this.storage.getItem(this.tokenKey)
  }

  getUser(): User {
    const token = this.storage.getItem(this.tokenKey)
    return jwt.decode(token) as User
  }

  logout(): void {
    this.storage.removeItem(this.tokenKey)
  }
}

export function createAuthProvider() {
  return new AuthProvider(localStorage)
}
